import React from 'react';
import styles from './SupplierCard.module.scss';
function SupplierCard({ supplier }) {
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("picture", { className: styles.picture }),
        React.createElement("div", { className: styles.main },
            React.createElement("h4", null, (supplier === null || supplier === void 0 ? void 0 : supplier.fullName) || (supplier === null || supplier === void 0 ? void 0 : supplier.shortName) || '-'),
            React.createElement("p", null, (supplier === null || supplier === void 0 ? void 0 : supplier.code) || '-'))));
}
export default SupplierCard;
